import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const notFoundMessages = [
  "The page you are looking for doesn't exist or has been moved.",
  "Oops! Where did you go?",
  "Looks like you're lost in the void.",
  "This page has taken a vacation.",
  "The requested page is playing hide and seek.",
  "We couldn't find what you were looking for.",
  "Hmm, this page seems to be out of order.",
  "You’ve hit a dead end. Let’s find your way back.",
  "This page has wandered off. Let’s find it!",
  "404? More like 'not found!'",
  "The page you're looking for has flown away.",
];

const PageNotFound = () => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    const updateMessage = () => {
      setMessage(
        notFoundMessages[Math.floor(Math.random() * notFoundMessages.length)]
      );
    };

    updateMessage();
    const interval = setInterval(updateMessage, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <motion.div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
      className="bg-not-found"
    >
      <motion.h1
        className="not-found-heading"
        style={{
          margin: 0,
          background: "linear-gradient(60deg, #F3E8CB, #607e93)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
        animate={{ opacity: [0, 1], scale: [0.9, 1] }}
        transition={{ duration: 0.8 }}
      >
        404
      </motion.h1>

      <motion.p
        className="not-found-text"
        key={message}
        initial={{ opacity: 0, y: 20 }}
        animate={{
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.7,
            delay: 0.3,
            ease: [0.42, 0, 0.58, 1],
          },
        }}
      >
        {message}
      </motion.p>
      <motion.a
        href="/"
        className="go-back-button"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        Go Back Home
      </motion.a>
    </motion.div>
  );
};

export default PageNotFound;
